import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useFamilyOffice } from '../contexts/FamilyOfficeContext';

export default function FamilyOfficeSwitcher() {
  const { accessibleFos, activeFoId, setActiveFoId } = useFamilyOffice();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  if (accessibleFos.length === 0) return null;

  if (accessibleFos.length === 1) {
    return <span className="fo-pill">{accessibleFos[0].short_code || accessibleFos[0].name}</span>;
  }

  const active = accessibleFos.find((f) => f.id === activeFoId) || accessibleFos[0];

  return (
    <div className="fo-switcher-wrap" ref={wrapRef}>
      <button
        type="button"
        className={`fo-switcher-btn ${open ? 'open' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span>{active.short_code || active.name}</span>
        <ChevronDown size={14} className={`fo-chev ${open ? 'rot' : ''}`} />
      </button>
      {open && (
        <ul className="fo-menu" role="listbox">
          {accessibleFos.map((fo) => (
            <li
              key={fo.id}
              role="option"
              aria-selected={fo.id === active.id}
              className={`fo-menu-item ${fo.id === active.id ? 'selected' : ''}`}
              onClick={() => {
                setActiveFoId(fo.id);
                setOpen(false);
              }}
            >
              {fo.short_code || fo.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
